// use client: activeTag state drives the report tag filter buttons
'use client'

import { useState } from 'react'
import { Col, Row, Stack } from 'react-bootstrap'
import parse from 'html-react-parser'

import Link from '@/components/Link'

import './report.css'

import type { CmsItem } from '@/utils/api'

import moment from 'moment'

// import { financialReportList } from "constants/financialReport";

function FinancialReport({
  initialData
}: {
  initialData?: CmsItem<'/financial-reports'>[] | null
}) {
  const initialReports = initialData ?? []
  const initialTags = [...new Set(initialReports.map(item => item.tag))].filter(
    (t): t is string => t != null
  )
  // Content comes from the build-time snapshot only. A Strapi publish rebuilds
  // and redeploys the site, so there is nothing to revalidate on mount.
  // See tests/no-client-cms-fetch.spec.ts.
  const tags = initialTags
  const financialReportList = initialReports
  const [activeTag, setActiveTag] = useState(initialTags[0] ?? '')
  return (
    <div className="container page">
      <h1 className="page-title">Financial Reports</h1>
      {/* todo: button active color */}
      <Stack direction="horizontal" gap={3}>
        {tags.map(item => {
          return (
            <button
              key={item}
              type="button"
              className={activeTag === item ? 'btn-tag active' : 'btn-tag'}
              aria-pressed={activeTag === item}
              onClick={() => setActiveTag(item)}
            >
              {item}
            </button>
          )
        })}
      </Stack>

      <div className="report-section">
        <Row>
          {financialReportList
            .filter(x => x.tag === activeTag)
            .map(item => (
              <Col key={item.pdfLink} md={6} lg={4}>
                <div className="report-card d-flex flex-column justify-content-between content">
                  <div>
                    <h1>
                      {(item.title ?? '').length < 100
                        ? item.title
                        : (item.title ?? '').slice(0, 100) + '...'}
                    </h1>
                  </div>
                  <div>
                    <p>
                      {item.description.length < 130
                        ? parse(item.description)
                        : parse(item.description.slice(0, 130)) + '...'}
                    </p>
                    <div className="d-flex justify-content-between align-items-baseline report-link">
                      <Link href={item.pdfLink || '#'} target="_blank" rel="noopener noreferrer">
                        View Report
                      </Link>
                      <p>{moment(item.date).format('DD MMM YYYY')}</p>
                    </div>
                  </div>
                </div>
              </Col>
            ))}
        </Row>
      </div>
    </div>
  )
}

export default FinancialReport
